import request from '@/request'

/* 得到门诊信息 */
export const getBaseInfo = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getBaseInfo.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getUserCert = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getUserCert.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const queryClinic = data => {
  return request({
    url: '/inf_Clinc_Vipwd/queryClinic.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const queryClinicByAccountid = data => {
  return request({
    url: '/inf_Clinc_Vipwd/queryClinicByAccountid.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

export const getUserQueryMainList = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getUserQueryMainList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

export const getUserQueryDetailList = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getUserQueryDetailList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const pumpClinic = data => {
  return request({
    url: '/inf_Clinc_Vipwd/pumpClinic.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const replyClinic = data => {
  return request({
    url: '/inf_Clinc_Vipwd/replyClinic.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const getDealCount = data => {
  return request({
    url: '/inf_Clinc_Vipwd/getDealCount.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
export const deleteQuery = data => {
  return request({
    url: '/inf_Clinc_Vipwd/deleteQuery.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
